import { fromJS } from 'immutable';

import * as rolesActions from '../actions/roles';
import { fetchingState } from '@constants';

const initialStats = {
  roleList: {},
  formAssoc: {},
  formAssocList: {},
  eventFormList: {},
};

export default (state = fromJS(initialStats), action) => {
  switch (action.type) {
    case rolesActions.ROLES_FETCH_START: {
      return state.setIn(['roleList', 'state'], fetchingState.FETCHING);
    }
    case rolesActions.ROLES_FETCH_SUCCESS: {
      return state
        .setIn(['roleList', 'state'], fetchingState.LOADED)
        .setIn(
          ['roleList', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case rolesActions.ROLES_FETCH_ERROR: {
      return state.setIn(['roleList', 'state'], fetchingState.ERROR);
    }

    case rolesActions.FORM_ASSOCS_FETCH_START: {
      return state.setIn(['formAssocList', 'state'], fetchingState.FETCHING);
    }
    case rolesActions.FORM_ASSOCS_FETCH_SUCCESS: {
      return state
        .setIn(['formAssocList', 'state'], fetchingState.LOADED)
        .setIn(
          ['formAssocList', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case rolesActions.FORM_ASSOCS_FETCH_ERROR: {
      return state.setIn(['formAssocList', 'state'], fetchingState.ERROR);
    }

    case rolesActions.EVENT_FORMS_FETCH_START: {
      return state.setIn(['eventFormList', 'state'], fetchingState.FETCHING);
    }
    case rolesActions.EVENT_FORMS_FETCH_SUCCESS: {
      return state
        .setIn(['eventFormList', 'state'], fetchingState.LOADED)
        .setIn(
          ['eventFormList', 'data'],
          fromJS(action.data ? action.data.results : []),
        );
    }
    case rolesActions.EVENT_FORMS_FETCH_ERROR: {
      return state.setIn(['eventFormList', 'state'], fetchingState.ERROR);
    }

    case rolesActions.FORM_ASSOC_CREATE_START: {
      return state.setIn(['formAssoc', 'state'], fetchingState.SAVING);
    }
    case rolesActions.FORM_ASSOC_CREATE_SUCCESS: {
      return state
        .setIn(['formAssoc', 'state'], fetchingState.LOADED)
        .setIn(
          ['formAssocList', 'data'],
          fromJS(
            (state.getIn(['formAssocList', 'data'])
              ? state.getIn(['formAssocList', 'data']).toJS()
              : []
            ).concat([action.data.results[0]]),
          ),
        );
    }
    case rolesActions.FORM_ASSOC_CREATE_ERROR: {
      return state.setIn(['formAssoc', 'state'], fetchingState.ERROR);
    }

    case rolesActions.FORM_ASSOC_DELETE_START: {
      return state.setIn(['formAssoc', 'state'], fetchingState.SAVING);
    }
    case rolesActions.FORM_ASSOC_DELETE_SUCCESS: {
      return state
        .setIn(['formAssoc', 'state'], fetchingState.LOADED)
        .setIn(
          ['formAssocList', 'data'],
          fromJS(
            (state.getIn(['formAssocList', 'data'])
              ? state.getIn(['formAssocList', 'data']).toJS()
              : []
            ).filter(formAssoc => formAssoc.assocID !== action.assocID),
          ),
        );
    }
    case rolesActions.FORM_ASSOC_DELETE_ERROR: {
      return state.setIn(['formAssoc', 'state'], fetchingState.ERROR);
    }

    case rolesActions.FORM_ASSOCS_DELETE_START: {
      return state.setIn(['formAssocList', 'state'], fetchingState.FETCHING);
    }
    case rolesActions.FORM_ASSOCS_DELETE_SUCCESS: {
      return state
        .setIn(['formAssocList', 'state'], fetchingState.LOADED)
        .setIn(['formAssocList', 'data'], fromJS([]));
    }
    case rolesActions.FORM_ASSOCS_DELETE_ERROR: {
      return state.setIn(['formAssocList', 'state'], fetchingState.ERROR);
    }

    default: {
      return state;
    }
  }
};
